import Loading from "../components/loading"

function LoadingTest() {

    return (
        <Loading></Loading>
    )
}

export default LoadingTest